import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: "'Quicksand', Helvetica, Arial, sans-serif",
    },
});

export default theme;
